import type {
  CrmFunnelStatusItem,
  CrmStatusTransitions,
} from '@/api/types/crm/crmFunnels.types'

export const getStatusTransitions = (
  status: Pick<CrmFunnelStatusItem, 'transitions'> | null | undefined,
): CrmStatusTransitions => {
  const raw = status?.transitions
  if (!raw || typeof raw !== 'object') {
    return { restricted: false, allowed_status_ids: [] }
  }
  const ids = Array.isArray(raw.allowed_status_ids)
    ? raw.allowed_status_ids
        .map(Number)
        .filter((id) => Number.isFinite(id) && id > 0)
    : []
  return {
    restricted: Boolean(raw.restricted),
    allowed_status_ids: ids,
  }
}

/** Можно ли перенести из статуса-источника в целевой. */
export const isStatusTransitionAllowed = (
  fromTransitions: CrmStatusTransitions | null | undefined,
  toStatusId: number,
): boolean => {
  if (!Number.isFinite(toStatusId) || toStatusId <= 0) return false
  const transitions = fromTransitions ?? {
    restricted: false,
    allowed_status_ids: [],
  }
  if (!transitions.restricted) return true
  return transitions.allowed_status_ids.includes(toStatusId)
}

export const buildTransitionsByStatusId = (
  statuses: CrmFunnelStatusItem[],
): Record<number, CrmStatusTransitions> => {
  const map: Record<number, CrmStatusTransitions> = {}
  statuses.forEach((status) => {
    map[status.id] = getStatusTransitions(status)
  })
  return map
}

export const buildStatusNameById = (
  statuses: CrmFunnelStatusItem[],
): Record<number, string> => {
  const map: Record<number, string> = {}
  statuses.forEach((status) => {
    map[status.id] = status.name
  })
  return map
}

export const formatStatusTransitionForbiddenMessage = (
  fromName: string,
  toName: string,
): string =>
  `Переход из статуса «${fromName}» в статус «${toName}» запрещён настройками воронки.`
